import { DeleteOutlined, FilePdfOutlined, PlusOutlined, SearchOutlined, SettingOutlined } from "@ant-design/icons";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import aclaracionCobroPdf, { folioDocumento } from "./aclaracionCobroPdf";
import { Col, Descriptions, message, Modal, PageHeader, Row, Space, Spin, Table, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { ButtonItem, Form, FormItem, InputItem, InputNumberItem, ModalItem, SegmentedItem, SelectItem, SwitchItem, TabbedDynamicTable, TableItem, TagItem, TextAreaItem } from "../../../../Components/Items";
import { colorPaleta } from "../../../../Components/TagItem";
import { cicloCobro, formatoDinero, nombreDocumento, postCobro } from "./cobroBiwoTextos";
import SelectClientesEmisoraBiwoItem from "../../../../Components/SelectClientesEmisoraBiwoItem";
import moment from "moment";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const TARJETA = { backgroundColor: "white", borderRadius: 12, padding: 20, boxShadow: "0 2px 8px rgba(0,0,0,0.06)" };
const BARRA = { display: "flex", flexWrap: "wrap", alignItems: "center", gap: 12, padding: "10px 14px", marginBottom: 12, backgroundColor: "white", border: "1px solid #f0f0f0", borderRadius: 8 };
const TITULO_SECCION = { fontSize: 14, fontWeight: 600, color: "#333", margin: "16px 0 8px" };
const TIPOS_RECEPTOR = [
    { value: "propio", label: "Su propio RFC" },
    { value: "cliente", label: "Cliente ligado" },
    { value: "otro", label: "Otro receptor" },
];
const tipoReceptor = (r = {}) => (["propio", "cliente", "otro"].includes(r.tipo) ? r.tipo : r.propio === false ? "otro" : r.clienteId ? "cliente" : "propio");
const Celda = ({ children }) => <td className="td-border">{children}</td>;
const Campo = (props) => <FormItem noStyle {...props} />;

class MastersCobro extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        masters: [],
        texto: "",
        master: null,
        cargandoMaster: false,
        configuracion: null,
        calculo: null,
        sinEspeciales: false,
        modalGenerar: false,
        cuentaComoPeriodo: true,
        generando: false,
        cortes: [],
        clientesElegidos: {},
        conceptos: [],
        combos: [],
    };

    componentDidMount() {
        if (!this.props.usuarioId) return this.consultar();
        this.setState({ cargandoMaster: true });
        postCobro(axios, "selectMastersCobro", {}, this.props.headersToken).then((data) => {
            const master = (data.success === 2 ? data.data : []).find((m) => String(m._id) === String(this.props.usuarioId));
            if (master) this.abrir(master);
            else this.setState({ cargandoMaster: false, noEncontrado: true });
        });
    }

    irAMaster = (master) => this.props.history.push("/panelPrincipal/cobroMasterBiwo/" + master._id);

    volver = () => this.props.history.push({ pathname: "/panelPrincipal/empresasBiwo", state: { pestana: "masters" } });

    consultar = () => {
        this.setState({ loading: true });
        postCobro(axios, "selectMastersCobro", { texto: this.state.texto }, this.props.headersToken)
            .then((data) => this.setState({ loading: false, masters: data.success === 2 ? data.data : [] }))
            .catch(() => this.setState({ loading: false }));
    };

    abrir = (master) => {
        this.setState({ master, cargandoMaster: true, configuracion: null, calculo: null, sinEspeciales: false, cortes: [] });
        Promise.all([
            postCobro(axios, "selectConfiguracionMaster", { usuarioId: master._id }, this.props.headersToken),
            postCobro(axios, "selectConceptosCobro", {}, this.props.headersToken),
            postCobro(axios, "selectCombosCobro", {}, this.props.headersToken),
        ]).then(([config, conceptos, combos]) => {
            this.setState({
                cargandoMaster: false,
                configuracion: config.success === 2 ? config.data || {} : {},
                conceptos: conceptos.success === 2 ? conceptos.data : [],
                combos: combos.success === 2 ? combos.data : [],
            });
            this.calcular();
        });
    };

    calcular = () => {
        const { master, sinEspeciales } = this.state;
        postCobro(axios, "calcularCobroMaster", { usuarioId: master._id, sinEspeciales }, this.props.headersToken).then((data) => {
            if (data.success === 2) this.setState({ calculo: data.data });
        });
        postCobro(axios, "selectCortesCobro", { usuarioId: master._id }, this.props.headersToken).then((data) => {
            if (data.success === 2) this.setState({ cortes: data.data });
        });
    };

    cambiarOpcion = (cambio) => this.setState({ ...cambio, calculo: null }, this.calcular);

    generar = (confirmarDuplicado = false) => {
        const { master, sinEspeciales, cuentaComoPeriodo, clientesElegidos, tipoGenerar } = this.state;
        this.setState({ generando: true });
        postCobro(axios, "generarRemisionCobro", { usuarioId: master._id, sinEspeciales, cuentaComoPeriodo, confirmarDuplicado, clientesElegidos, tipoDocumento: tipoGenerar }, this.props.headersToken).then((data) => {
            this.setState({ generando: false });
            if (data.success === 3) {
                Modal.confirm({
                    title: "Este periodo ya tiene cobro generado",
                    content: `Folios: ${data.folios.join(", ") || "sin folio"}. ¿Generar otra?`,
                    okText: "Sí, generar otra",
                    cancelText: "No",
                    onOk: () => this.generar(true),
                });
                return;
            }
            if (data.success === 4) {
                Modal.warning({
                    title: "Cobros no generados",
                    content: (
                        <>
                            {data.folios.length > 0 && <div style={{ marginBottom: 8 }}>Generadas: {data.folios.join(", ")}</div>}
                            {data.noGeneradas.map((n, i) => (
                                <div key={i}><b>{n.nombre}</b> {n.rfc && `(${n.rfc})`}: {n.motivo}</div>
                            ))}
                        </>
                    ),
                });
                this.calcular();
                return;
            }
            if (data.success === 2) {
                message.success(`${data.message}: ${data.folios.join(", ")}`);
                this.setState({ modalGenerar: false });
                this.calcular();
            } else {
                message.error(data.message || "No se pudo generar el cobro");
            }
        });
    };

    descargarAclaracion = (corte) => {
        postCobro(axios, "datosAclaracionCobro", { corteId: corte._id }, this.props.headersToken).then((data) => {
            if (data.success !== 2) return message.error(data.message || "No se pudo generar la aclaración");
            (data.documentos || []).forEach((documento) => {
                pdfMake.createPdf(aclaracionCobroPdf(documento)).download(`Aclaracion ${folioDocumento(documento) || "cobro"}.pdf`);
            });
        });
    };

    receptoresGenerar() {
        const { configuracion, calculo, master } = this.state;
        if (configuracion?.modo !== "porEmpresa") return [{ clave: "consolidado", nombre: configuracion?.receptorNombre || "Receptor", clienteId: configuracion?.clienteId }];
        const empresasConCobro = new Set((calculo?.partidas || []).map((p) => String(p.empresaId)));
        return (master?.empresas || [])
            .filter((e) => empresasConCobro.has(String(e._id)))
            .map((e) => ({
                clave: String(e._id),
                nombre: e.nombre,
                clienteId: (() => {
                    const receptor = (configuracion.receptoresEmpresa || []).find((r) => String(r.empresaId) === String(e._id));
                    return receptor && tipoReceptor(receptor) === "cliente" ? receptor.clienteId : undefined;
                })(),
            }));
    }

    abrirGenerar = () => {
        const clientesElegidos = Object.fromEntries(this.receptoresGenerar().map((r) => [r.clave, r.clienteId || undefined]));
        this.setState({ modalGenerar: true, cuentaComoPeriodo: true, clientesElegidos, tipoGenerar: this.state.calculo?.tipoDocumento === "factura" ? "factura" : "remision" });
    };

    renderModalGenerar() {
        const calculo = this.state.calculo;
        const tipo = this.state.tipoGenerar === "factura" ? "factura" : "remision";
        const factura = tipo === "factura";
        const sinInsumo = factura ? [] : (calculo?.partidas || []).filter((p) => !p.insumoId && p.importe > 0);
        return (
            <ModalItem
                visible={this.state.modalGenerar}
                title={factura ? "Generar factura" : "Generar remisión"}
                onCancel={() => this.setState({ modalGenerar: false })}
                footer={null}
                spinning={this.state.generando}
                width={600}
            >
                <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 8, marginBottom: 10 }}>
                    <span style={{ fontWeight: 600, color: "#333" }}>Documento</span>
                    <SegmentedItem
                        options={[{ label: "Remisión", value: "remision" }, { label: "Factura timbrada", value: "factura" }]}
                        value={tipo}
                        onChange={(valor) => this.setState({ tipoGenerar: valor })}
                    />
                    {tipo !== (calculo?.tipoDocumento === "factura" ? "factura" : "remision") && <TagItem naranja>Distinto a lo configurado</TagItem>}
                </div>
                <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 8, padding: "10px 14px", margin: "4px 0 12px", borderRadius: 8, backgroundColor: `${colorPaleta("cyan")}0F`, border: `1px solid ${colorPaleta("cyan")}59` }}>
                    <span style={{ color: "#595959" }}>Total sin IVA</span>
                    <span style={{ fontSize: 20, fontWeight: 600, color: "#333" }}>{formatoDinero(calculo?.total)}</span>
                    <span style={{ marginLeft: "auto", display: "flex", flexWrap: "wrap", gap: 4 }}>
                        <TagItem gris>IVA lo agrega la {nombreDocumento(tipo)}</TagItem>
                        {factura && <TagItem azul>Se timbra al generar</TagItem>}
                        {this.state.sinEspeciales && <TagItem naranja>Sin precios especiales</TagItem>}
                    </span>
                </div>
                {sinInsumo.length > 0 && (
                    <div style={{ marginBottom: 12, padding: "8px 12px", borderLeft: `3px solid ${colorPaleta("ambar")}`, backgroundColor: `${colorPaleta("ambar")}14`, borderRadius: 6 }}>
                        Sin insumo asignado, saldrán con el insumo general y una observación: {sinInsumo.map((p) => p.nombre).join(", ")}.
                    </div>
                )}
                <div style={{ fontWeight: 600, color: "#333", marginBottom: 8 }}>Cliente que recibe la {nombreDocumento(tipo)}</div>
                {this.receptoresGenerar().map((r) => (
                    <div key={r.clave} style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 8, marginBottom: 8 }}>
                        <span style={{ flex: "0 0 180px", maxWidth: "100%", fontWeight: 500 }}>{r.nombre}</span>
                        <div style={{ flex: "1 1 240px", minWidth: 0 }}>
                            <SelectClientesEmisoraBiwoItem
                                width="100%"
                                allowClear
                                placeholder="Sin elegir: se busca o se da de alta por RFC"
                                value={this.state.clientesElegidos[r.clave]}
                                onChange={(clienteId) => this.setState((st) => ({ clientesElegidos: { ...st.clientesElegidos, [r.clave]: clienteId } }))}
                            />
                        </div>
                    </div>
                ))}
                <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 8, marginTop: 12 }}>
                    <SegmentedItem
                        options={[{ label: "Cobro del periodo", value: "periodo" }, { label: "Cobro extra", value: "extra" }]}
                        value={this.state.cuentaComoPeriodo ? "periodo" : "extra"}
                        onChange={(valor) => this.setState({ cuentaComoPeriodo: valor === "periodo" })}
                    />
                    <span style={{ fontSize: 12, color: "#8c8c8c" }}>
                        {this.state.cuentaComoPeriodo ? "El automático ya no lo genera" : "El automático se genera en su fecha"}
                    </span>
                </div>
                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
                    <Space>
                        <ButtonItem danger onClick={() => this.setState({ modalGenerar: false })}>Cancelar</ButtonItem>
                        <ButtonItem verde onClick={() => this.generar(false)}>{factura ? "Generar y timbrar factura" : "Generar remisión"}</ButtonItem>
                    </Space>
                </div>
            </ModalItem>
        );
    }

    guardar = () => {
        this.formRef.current.validateFields().then((values) => {
            const preciosEspeciales = (values.preciosEspeciales || []).map(({ objetivo, ...p }) => {
                const [tipoObjetivo, objetivoId, nivelId] = String(objetivo || "").split(":");
                return { ...p, conceptoId: tipoObjetivo === "c" ? objetivoId : null, nivelId: nivelId || null, comboId: tipoObjetivo === "k" ? objetivoId : null };
            });
            const agrupacionFactura = Object.entries(values.agrupacionMapa || {})
                .filter(([, valor]) => valor === "agrupar" || valor === "aparte")
                .map(([clave, valor]) => {
                    const [tipo, objetivoId] = clave.split("_");
                    return { conceptoId: tipo === "c" ? objetivoId : null, comboId: tipo === "k" ? objetivoId : null, agrupar: valor === "agrupar" };
                });
            delete values.agrupacionMapa;
            if (values.facturarA !== "cliente") values.clienteId = null;
            this.setState({ cargandoMaster: true });
            postCobro(axios, "guardarConfiguracionMaster", { ...values, preciosEspeciales, agrupacionFactura, usuarioId: this.state.master._id }, this.props.headersToken).then((data) => {
                this.setState({ cargandoMaster: false });
                if (data.success === 2) {
                    message.success(data.message);
                    this.calcular();
                    this.consultar();
                } else {
                    message.error(data.message || "No se pudo guardar");
                }
            });
        });
    };

    opcionesObjetivo() {
        const opciones = [];
        for (const c of this.state.conceptos) {
            if (c.tipoPrecio === "niveles") {
                opciones.push({ value: `c:${c._id}`, label: `${c.nombre} (todos los paquetes)` });
                c.niveles.forEach((n) => opciones.push({ value: `c:${c._id}:${n._id}`, label: `${c.nombre} ${n.nombre}` }));
            } else {
                opciones.push({ value: `c:${c._id}`, label: c.nombre });
            }
        }
        this.state.combos.forEach((k) => opciones.push({ value: `k:${k._id}`, label: `Combo: ${k.nombre}` }));
        return opciones;
    }

    renderCalculo() {
        const calculo = this.state.calculo;
        if (!calculo) return <div style={{ padding: 40, textAlign: "center" }}><Spin /></div>;
        const aplicaA = (p) => (p.general ? (p.empresaNombre ? `${p.empresaNombre} (paga lo general)` : "Cuenta general del master") : p.empresaNombre);
        const opcionesAplicaA = [...new Set(calculo.partidas.map(aplicaA))].map((t) => ({ text: t, value: t }));
        const tipoCorte = (c) => (c.estado === "pendiente" ? "pendiente" : c.cuentaComoPeriodo ? "periodo" : "extra");
        return (
            <>
                <div style={BARRA}>
                    <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                        <SwitchItem size="small" checked={!this.state.sinEspeciales} onChange={(v) => this.cambiarOpcion({ sinEspeciales: !v })} /> Precios especiales
                    </span>
                    {(calculo.grupos?.length ? calculo.grupos : [{ ciclo: calculo.ciclo }]).map((g, i) => (
                        <TagItem azul style={{ margin: 0 }} key={g.empresaId || i}>
                            {g.nombre ? `${g.nombre}: ` : ""}
                            {g.ciclo
                                ? `cobra ${moment(g.ciclo.periodo.inicio).format("DD/MM/YYYY")} – ${moment(g.ciclo.periodo.fin).format("DD/MM/YYYY")}`
                                : "sin fecha de bloqueo"}
                        </TagItem>
                    ))}
                    {!calculo.configurado && <TagItem naranja style={{ margin: 0 }}>Sin configuración de cobro: no se le cobra nada</TagItem>}
                    <ButtonItem verde size="small" style={{ marginLeft: "auto" }} disabled={!calculo.configurado || !calculo.partidas.length} onClick={this.abrirGenerar}>
                        Generar remisión / factura
                    </ButtonItem>
                </div>
                <Table
                    size="small"
                    className="custom-small-table"
                    scroll={{ x: "max-content" }}
                    pagination={false}
                    rowKey={(p) => `${p.tipo}-${p.empresaId || "general"}-${p.comboId || p.conceptoId}`}
                    dataSource={calculo.partidas}
                    expandable={{
                        rowExpandable: (p) => p.tipo === "combo",
                        expandedRowRender: (p) => (
                            <Table
                                size="small"
                                className="custom-small-table"
                                pagination={false}
                                rowKey="clave"
                                dataSource={p.detalle || []}
                                columns={[
                                    { title: "Incluido en el combo", dataIndex: "nombre" },
                                    { title: "Precio unitario completo", dataIndex: "precioCompleto", render: formatoDinero, align: "right" },
                                    { title: "Unitario en el periodo", dataIndex: "cobroPeriodo", render: formatoDinero, align: "right" },
                                ]}
                                summary={(filas) => {
                                    const suelto = filas.reduce((s, f) => s + f.precioCompleto, 0);
                                    return (
                                        <Table.Summary.Row>
                                            <Table.Summary.Cell>Suelto {formatoDinero(suelto)} · Combo {formatoDinero(p.importeCompleto)}</Table.Summary.Cell>
                                            <Table.Summary.Cell align="right">{suelto > p.importeCompleto ? <TagItem verdeNatural>Ahorra {formatoDinero(suelto - p.importeCompleto)}</TagItem> : ""}</Table.Summary.Cell>
                                            <Table.Summary.Cell />
                                        </Table.Summary.Row>
                                    );
                                }}
                            />
                        ),
                    }}
                    columns={[
                        { title: "Aplica a", dataIndex: "empresaNombre", render: (v, p) => (p.general ? (v ? `${v} (paga lo general)` : "Cuenta general del master") : v), filters: opcionesAplicaA, onFilter: (valor, p) => aplicaA(p) === valor },
                        {
                            title: "Concepto",
                            dataIndex: "nombre",
                            render: (v, p) => (p.tipo === "combo" ? <>{v} <TagItem azul>Combo</TagItem></> : v),
                            filters: [{ text: "Combo", value: "combo" }, { text: "Concepto", value: "concepto" }],
                            onFilter: (valor, p) => (valor === "combo" ? p.tipo === "combo" : p.tipo !== "combo"),
                        },
                        { title: "Cant.", dataIndex: "cantidad", width: 60, align: "right", sorter: (a, b) => (a.cantidad || 0) - (b.cantidad || 0) },
                        { title: "Precio completo (sin IVA)", dataIndex: "importeCompleto", render: formatoDinero, align: "right", sorter: (a, b) => (a.importeCompleto || 0) - (b.importeCompleto || 0) },
                        { title: "Cobro del periodo (sin IVA)", dataIndex: "importe", render: formatoDinero, align: "right", sorter: (a, b) => (a.importe || 0) - (b.importe || 0) },
                        { title: "Observaciones", dataIndex: "observaciones" },
                    ]}
                    summary={() => (
                        <Table.Summary.Row>
                            <Table.Summary.Cell colSpan={4}><b>Total sin IVA</b></Table.Summary.Cell>
                            <Table.Summary.Cell align="right">{formatoDinero(calculo.partidas.reduce((s, p) => s + (p.importeCompleto || 0), 0))}</Table.Summary.Cell>
                            <Table.Summary.Cell align="right"><b>{formatoDinero(calculo.total)}</b></Table.Summary.Cell>
                            <Table.Summary.Cell>{calculo.ahorro > 0 ? <TagItem verdeNatural>Ahorra {formatoDinero(calculo.ahorro)}</TagItem> : ""}</Table.Summary.Cell>
                        </Table.Summary.Row>
                    )}
                />
                {this.state.cortes.length > 0 && (
                    <>
                        <div style={TITULO_SECCION}>Cobros generados</div>
                        <Table
                            size="small"
                            className="custom-small-table"
                            scroll={{ x: "max-content" }}
                            rowKey="_id"
                            pagination={false}
                            dataSource={this.state.cortes}
                            columns={[
                                { title: "Fecha", dataIndex: "createdAt", render: (v) => moment(v).format("DD/MM/YYYY HH:mm"), sorter: (a, b) => moment(a.createdAt).valueOf() - moment(b.createdAt).valueOf() },
                                { title: "Periodo", render: (c) => `${moment(c.periodoInicio).format("DD/MM/YYYY")} – ${moment(c.periodoFin).format("DD/MM/YYYY")}`, sorter: (a, b) => moment(a.periodoInicio).valueOf() - moment(b.periodoInicio).valueOf() },
                                { title: "Folios", render: (c) => (c.remisiones || []).map((r) => r.folio).join(", ") },
                                {
                                    title: "No generadas",
                                    render: (c) =>
                                        (c.noGeneradas || []).length
                                            ? c.noGeneradas.map((n, i) => (
                                                <div key={i}><b>{n.nombre}</b> {n.rfc && `(${n.rfc})`}: {n.motivo}</div>
                                            ))
                                            : "—",
                                },
                                { title: "Subtotal (sin IVA)", dataIndex: "subtotal", render: formatoDinero, align: "right", sorter: (a, b) => (a.subtotal || 0) - (b.subtotal || 0) },
                                { title: "Documento", dataIndex: "tipoDocumento", render: (v) => (v === "factura" ? "Factura" : "Remisión") },
                                {
                                    title: "Pago",
                                    filters: [
                                        { text: "Pagado", value: "pagado" },
                                        { text: "Por pagar", value: "porPagar" },
                                    ],
                                    onFilter: (valor, c) => (valor === "pagado" ? !!c.pagoAplicado : !c.pagoAplicado),
                                    render: (c) =>
                                        c.pagoAplicado ? (
                                            <Tooltip title={`Pagado el ${moment(c.fechaPagoAplicado).format("DD/MM/YYYY HH:mm")}`}>
                                                <TagItem verdeNatural>Bloqueo al {moment(c.fechaBloqueoNueva).format("DD/MM/YYYY")}</TagItem>
                                            </Tooltip>
                                        ) : c.estado === "pendiente" || !c.cuentaComoPeriodo ? (
                                            "—"
                                        ) : (
                                            <TagItem naranja>Por pagar</TagItem>
                                        ),
                                },
                                {
                                    title: "Tipo",
                                    filters: [
                                        { text: "Pendiente de generar", value: "pendiente" },
                                        { text: "Cobro del periodo", value: "periodo" },
                                        { text: "Extra", value: "extra" },
                                        { text: "Automático", value: "automatico" },
                                    ],
                                    onFilter: (valor, c) => (valor === "automatico" ? c.estado !== "pendiente" && c.origen === "automatico" : tipoCorte(c) === valor),
                                    render: (c) =>
                                        c.estado === "pendiente" ? (
                                            <Tooltip title={c.mensaje}>
                                                <TagItem naranja>Pendiente de generar</TagItem>
                                            </Tooltip>
                                        ) : (
                                            <>
                                                {c.cuentaComoPeriodo ? <TagItem verdeNatural>Cobro del periodo</TagItem> : <TagItem gris>Extra</TagItem>}
                                                {c.origen === "automatico" && <TagItem gris>Automático</TagItem>}
                                            </>
                                        ),
                                },
                                {
                                    title: "Opciones",
                                    render: (c) => (c.opciones?.sinEspeciales ? "Sin precios especiales" : "—"),
                                },
                                {
                                    title: "Acciones",
                                    key: "acciones",
                                    render: (c) =>
                                        (c.remisiones || []).length > 0 && (
                                            <Tooltip title="PDF de aclaración">
                                                <ButtonItem cyan size="small" icon={<FilePdfOutlined />} onClick={() => this.descargarAclaracion(c)} />
                                            </Tooltip>
                                        ),
                                },
                            ]}
                        />
                    </>
                )}
                {this.renderModalGenerar()}
            </>
        );
    }

    renderAgrupacion() {
        const filas = [
            ...this.state.conceptos.map((c) => ({ clave: `c_${c._id}`, nombre: c.nombre, tipo: "Concepto", catalogo: c.agruparFactura !== false })),
            ...this.state.combos.map((k) => ({ clave: `k_${k._id}`, nombre: k.nombre, tipo: "Combo", catalogo: k.agruparFactura !== false })),
        ];
        const texto = (agrupa) => (agrupa ? "Mensualidad BIWO" : "Aparte");
        return (
            <Table
                size="small"
                className="custom-small-table"
                scroll={{ x: "max-content" }}
                pagination={false}
                rowKey="clave"
                dataSource={filas}
                columns={[
                    { title: "Concepto o combo", dataIndex: "nombre" },
                    { title: "Tipo", dataIndex: "tipo", width: 110, filters: [{ text: "Concepto", value: "Concepto" }, { text: "Combo", value: "Combo" }], onFilter: (v, f) => f.tipo === v },
                    { title: "Catálogo", dataIndex: "catalogo", width: 170, render: (agrupa) => (agrupa ? <TagItem cyan>Mensualidad BIWO</TagItem> : <TagItem gris>Aparte</TagItem>) },
                    {
                        title: "Este cliente",
                        width: 280,
                        render: (f) => (
                            <Campo name={["agrupacionMapa", f.clave]} initialValue="catalogo">
                                <SelectItem
                                    width="100%"
                                    options={[
                                        { value: "catalogo", label: `Como el catálogo (${texto(f.catalogo)})` },
                                        { value: "agrupar", label: "Mensualidad BIWO" },
                                        { value: "aparte", label: "Aparte" },
                                    ]}
                                />
                            </Campo>
                        ),
                    },
                ]}
            />
        );
    }

    renderFechasCiclo(getFieldValue) {
        const empresas = this.state.master?.empresas || [];
        const datos = { periodicidad: getFieldValue("periodicidad"), diasAntesEmision: getFieldValue("diasAntesEmision") };
        const fechas = empresas.map((e) => e.fechaVencimiento).filter(Boolean).sort((a, b) => moment(a).valueOf() - moment(b).valueOf());
        const filas =
            getFieldValue("modo") === "porEmpresa"
                ? empresas.map((e) => ({ clave: e._id, nombre: e.nombre, ciclo: cicloCobro(moment, datos, e.fechaVencimiento) }))
                : [{ clave: "consolidado", nombre: "Todas sus empresas", ciclo: cicloCobro(moment, datos, fechas[0]) }];
        const estado =
            getFieldValue("activo") === false ? <TagItem naranja>Cobro apagado</TagItem> : getFieldValue("remisionAutomatica") === false ? <TagItem naranja>Automático apagado: queda pendiente</TagItem> : <TagItem azul>Automático 7:00 am</TagItem>;
        const fecha = (campo) => (_, f) => (f.ciclo ? f.ciclo[campo] : campo === "emision" ? <TagItem naranja>Sin fecha de bloqueo</TagItem> : "—");
        return (
            <Col span={24} style={{ marginBottom: 12 }}>
                <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 8, marginBottom: 6 }}>
                    <span style={{ fontWeight: 600, color: "#333" }}>Fechas del ciclo</span>
                    {estado}
                </div>
                <Table
                    size="small"
                    className="custom-small-table"
                    scroll={{ x: "max-content" }}
                    pagination={false}
                    rowKey="clave"
                    dataSource={filas}
                    columns={[
                        { title: "Empresa", dataIndex: "nombre" },
                        { title: "Emisión", render: fecha("emision") },
                        { title: "Corte", render: fecha("corte") },
                        { title: "Bloqueo", render: (_, f) => (f.ciclo ? <b>{f.ciclo.bloqueo}</b> : "—") },
                        { title: "Periodo que cobra", render: fecha("periodo") },
                        { title: "Al pagar, bloqueo al", render: fecha("siguienteBloqueo") },
                    ]}
                />
            </Col>
        );
    }

    renderGenerales() {
        const empresas = this.state.master?.empresas || [];
        const receptorEditable = (getFieldValue) => getFieldValue("facturarA") === "otro" || !empresas.find((e) => e._id === getFieldValue("facturarA"))?.rfc;
        return (
            <Row gutter={12}>
                <Col span={12}>
                    <FormItem margin label="Cobrar con este esquema" name="activo" valuePropName="checked" tooltip="Encendido: se le calcula y genera el cobro con esta configuración, y sus empresas pueden encender módulos (se les empiezan a cobrar) pero no apagarlos. Apagado: no se le cobra por aquí y sus empresas manejan sus módulos como siempre.">
                        <SwitchItem />
                    </FormItem>
                </Col>
                <Col span={12}>
                    <FormItem margin label="Periodicidad" name="periodicidad">
                        <SelectItem width="100%" options={[{ value: "mensual", label: "Mensual" }, { value: "anual", label: "Anual" }]} />
                    </FormItem>
                </Col>
                <Col span={12}>
                    <FormItem noStyle shouldUpdate={(a, b) => a.periodicidad !== b.periodicidad}>
                        {({ getFieldValue }) =>
                            getFieldValue("periodicidad") === "anual" && (
                                <FormItem margin label="Meses que se cobran" name="mesesAnual" tooltip="El plan anual cubre 12 meses y se cobra este número de meses. 12 = sin descuento; 10 = regala 2 meses.">
                                    <InputNumberItem min={1} max={12} precision={0} />
                                </FormItem>
                            )
                        }
                    </FormItem>
                </Col>
                <Col span={12}>
                    <FormItem margin label="Documento" name="tipoDocumento">
                        <SelectItem width="100%" options={[{ value: "remision", label: "Remisión" }, { value: "factura", label: "Factura timbrada" }]} />
                    </FormItem>
                </Col>
                <Col span={12}>
                    <FormItem margin label="Días antes del corte" name="diasAntesEmision" rules={[{ required: true, message: "Captura los días" }]}>
                        <InputNumberItem min={0} max={60} precision={0} />
                    </FormItem>
                </Col>
                <FormItem noStyle shouldUpdate={(a, b) => ["periodicidad", "diasAntesEmision", "modo", "remisionAutomatica", "activo"].some((c) => a[c] !== b[c])}>
                    {({ getFieldValue }) => this.renderFechasCiclo(getFieldValue)}
                </FormItem>
                <Col span={12}>
                    <FormItem margin label="Facturación" name="modo">
                        <SelectItem width="100%" options={[{ value: "consolidado", label: "Consolidada (una para todo)" }, { value: "porEmpresa", label: "Una por empresa (RFC de cada una)" }]} />
                    </FormItem>
                </Col>
                <FormItem noStyle shouldUpdate={(a, b) => a.modo !== b.modo || a.facturarA !== b.facturarA || a.receptoresEmpresa !== b.receptoresEmpresa}>
                    {({ getFieldValue }) =>
                        getFieldValue("modo") === "consolidado" ? (
                            <>
                                <Col span={12}>
                                    <FormItem margin label="Facturar a" name="facturarA">
                                        <SelectItem
                                            width="100%"
                                            options={[
                                                ...empresas.map((e) => ({ value: e._id, label: e.rfc ? `${e.nombre} - ${e.rfc}` : `${e.nombre} (sin RFC)` })),
                                                { value: "cliente", label: "Cliente ligado" },
                                                { value: "otro", label: "Otra persona / RFC" },
                                            ]}
                                            onChange={(valor) => {
                                                const empresa = empresas.find((e) => e._id === valor);
                                                this.formRef.current.setFieldsValue(
                                                    empresa ? { receptorRfc: empresa.rfc, receptorNombre: empresa.nombre } : { receptorRfc: "", receptorNombre: "" }
                                                );
                                            }}
                                        />
                                    </FormItem>
                                </Col>
                                {getFieldValue("facturarA") === "cliente" ? (
                                    <Col span={12}>
                                        <FormItem margin label="Cliente ligado" name="clienteId" rules={[{ required: true, message: "Elige el cliente" }]} tooltip="La factura o remisión sale a este cliente de la emisora, con su RFC, razón social, forma de pago, uso de CFDI, lista de precios y vendedor.">
                                            <SelectClientesEmisoraBiwoItem width="100%" placeholder="Cliente de la emisora" />
                                        </FormItem>
                                    </Col>
                                ) : (
                                    <>
                                        <Col span={12}>
                                            <FormItem margin label="RFC receptor" name="receptorRfc" required>
                                                <InputItem maxLength={13} disabled={!receptorEditable(getFieldValue)} />
                                            </FormItem>
                                        </Col>
                                        <Col span={12}>
                                            <FormItem margin label="Razón social" name="receptorNombre" required>
                                                <InputItem disabled={!receptorEditable(getFieldValue)} />
                                            </FormItem>
                                        </Col>
                                    </>
                                )}
                            </>
                        ) : (
                            <>
                                <Col span={12}>
                                    <FormItem margin label="Paga lo general" name="empresaGeneralId" required tooltip="Empresa a la que se le cargan usuarios y empresas">
                                        <SelectItem width="100%" options={empresas.map((e) => ({ value: e._id, label: e.nombre }))} />
                                    </FormItem>
                                </Col>
                                <Col span={24} style={{ marginBottom: 12 }}>
                                    <Form.List name="receptoresEmpresa">
                                        {(fields) => {
                                            const filaDe = (name) => getFieldValue(["receptoresEmpresa", name]) || {};
                                            const empresaDe = (name) => empresas.find((e) => e._id === filaDe(name).empresaId);
                                            return (
                                                <Table
                                                    size="small"
                                                    className="custom-small-table"
                                                    scroll={{ x: "max-content" }}
                                                    pagination={false}
                                                    rowKey="key"
                                                    dataSource={fields}
                                                    columns={[
                                                        { title: "Empresa", render: (_, { name }) => empresaDe(name)?.nombre },
                                                        {
                                                            title: "Factura a",
                                                            width: 160,
                                                            render: (_, { name }) => (
                                                                <FormItem noStyle name={[name, "tipo"]}>
                                                                    <SelectItem width="100%" options={TIPOS_RECEPTOR} />
                                                                </FormItem>
                                                            ),
                                                        },
                                                        {
                                                            title: "RFC receptor",
                                                            width: 130,
                                                            render: (_, { name }) => {
                                                                const tipo = filaDe(name).tipo;
                                                                if (tipo === "otro") {
                                                                    return (
                                                                        <FormItem noStyle name={[name, "rfc"]} required>
                                                                            <InputItem maxLength={13} placeholder="RFC" />
                                                                        </FormItem>
                                                                    );
                                                                }
                                                                return tipo === "cliente" ? <span style={{ color: "#8c8c8c" }}>El del cliente</span> : empresaDe(name)?.rfc || "Sin RFC";
                                                            },
                                                        },
                                                        {
                                                            title: "Razón social",
                                                            render: (_, { name }) => {
                                                                const tipo = filaDe(name).tipo;
                                                                if (tipo === "otro") {
                                                                    return (
                                                                        <FormItem noStyle name={[name, "nombre"]} required>
                                                                            <InputItem placeholder="Razón social" />
                                                                        </FormItem>
                                                                    );
                                                                }
                                                                return tipo === "cliente" ? <span style={{ color: "#8c8c8c" }}>La del cliente</span> : empresaDe(name)?.nombre;
                                                            },
                                                        },
                                                        {
                                                            title: "Cliente ligado",
                                                            width: 260,
                                                            render: (_, { name }) =>
                                                                filaDe(name).tipo === "cliente" ? (
                                                                    <FormItem noStyle name={[name, "clienteId"]} rules={[{ required: true, message: "Elige el cliente" }]}>
                                                                        <SelectClientesEmisoraBiwoItem width="100%" placeholder="Cliente de la emisora" />
                                                                    </FormItem>
                                                                ) : (
                                                                    "—"
                                                                ),
                                                        },
                                                    ]}
                                                />
                                            );
                                        }}
                                    </Form.List>
                                </Col>
                            </>
                        )
                    }
                </FormItem>
                <Col span={12}>
                    <FormItem margin label="Cobro automático" name="remisionAutomatica" valuePropName="checked">
                        <SwitchItem />
                    </FormItem>
                </Col>
                <Col span={12}>
                    <FormItem margin label="Observaciones internas" name="observaciones">
                        <TextAreaItem rows={2} />
                    </FormItem>
                </Col>
            </Row>
        );
    }

    renderContenido() {
        const { master, configuracion } = this.state;
        const cerrar = this.volver;
        const especiales = (configuracion?.preciosEspeciales || []).map((p) => ({
            ...p,
            objetivo: p.comboId ? `k:${p.comboId}` : `c:${p.conceptoId}${p.nivelId ? `:${p.nivelId}` : ""}`,
            empresaId: p.empresaId || "",
        }));
        const opcionesEmpresa = [{ value: "", label: "Todas sus empresas" }, ...(master?.empresas || []).map((e) => ({ value: e._id, label: e.nombre }))];
        const empresasMaster = master?.empresas || [];
        const empresaReceptora = configuracion?.receptorRfc
            ? empresasMaster.find((e) => e.rfc && e.rfc.toUpperCase() === configuracion.receptorRfc.toUpperCase())
            : empresasMaster.find((e) => e.rfc) || empresasMaster[0];
        const receptor = configuracion?.clienteId
            ? { facturarA: "cliente", receptorRfc: configuracion.receptorRfc || "", receptorNombre: configuracion.receptorNombre || "" }
            : configuracion?.receptorRfc && !empresaReceptora
            ? { facturarA: "otro", receptorRfc: configuracion.receptorRfc, receptorNombre: configuracion.receptorNombre }
            : { facturarA: empresaReceptora?._id, receptorRfc: empresaReceptora?.rfc || "", receptorNombre: configuracion?.receptorNombre || empresaReceptora?.nombre || "" };

        return (
            <>
                {master && (
                    <>
                        <Descriptions size="small" column={{ xs: 1, sm: 2, md: 3 }} style={{ margin: "4px 0 8px" }}>
                            <Descriptions.Item label="Corporativo">{master.nombreCorporativo || "—"}</Descriptions.Item>
                            <Descriptions.Item label="Empresas">{master.conteos.empresas}</Descriptions.Item>
                            <Descriptions.Item label="Próximo bloqueo">{master.conteos.fechaBloqueo ? moment(master.conteos.fechaBloqueo).format("DD/MM/YYYY") : "—"}</Descriptions.Item>
                        </Descriptions>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 14 }}>
                            {[
                                { titulo: "Usuarios", valor: master.conteos.usuariosTotales, color: colorPaleta("azul") },
                                { titulo: "Se cobran", valor: master.conteos.usuarios, color: colorPaleta("cyan"), destacado: true },
                                { titulo: "Contadores externos", valor: master.conteos.contadorExterno, color: colorPaleta("lila") },
                                { titulo: "Soporte BIWO", valor: master.conteos.soporteBiwo, color: colorPaleta("turquesa") },
                                { titulo: "Deshabilitados", valor: master.conteos.deshabilitados, color: colorPaleta("gris") },
                            ].map((t) => (
                                <div
                                    key={t.titulo}
                                    style={{
                                        flex: "1 1 150px",
                                        padding: "10px 14px",
                                        borderRadius: 8,
                                        backgroundColor: "white",
                                        border: "1px solid #f0f0f0",
                                        borderLeft: `4px solid ${t.color}`,
                                        boxShadow: t.destacado ? `0 0 0 2px ${t.color}55` : "0 2px 8px rgba(0,0,0,0.06)",
                                    }}
                                >
                                    <div style={{ fontSize: 12, color: "#8c8c8c", fontWeight: 500 }}>{t.titulo}</div>
                                    <div style={{ fontSize: 22, fontWeight: 600, color: t.destacado ? t.color : "#333" }}>{t.valor}</div>
                                </div>
                            ))}
                        </div>
                    </>
                )}
                {configuracion && (
                    <Form
                        ref={this.formRef}
                        layout
                        initialValues={{
                            activo: configuracion._id ? configuracion.activo !== false : true,
                            periodicidad: configuracion.periodicidad || "mensual",
                            mesesAnual: configuracion.mesesAnual || 12,
                            tipoDocumento: configuracion.tipoDocumento || "remision",
                            diasAntesEmision: Number.isInteger(configuracion.diasAntesEmision) ? configuracion.diasAntesEmision : 10,
                            modo: configuracion.modo || "consolidado",
                            ...receptor,
                            clienteId: configuracion.clienteId || undefined,
                            empresaGeneralId: configuracion.empresaGeneralId || empresasMaster[0]?._id,
                            receptoresEmpresa: empresasMaster.map((e) => {
                                const guardado = (configuracion.receptoresEmpresa || []).find((r) => r.empresaId === e._id);
                                return guardado ? { ...guardado, tipo: tipoReceptor(guardado) } : { empresaId: e._id, tipo: "propio" };
                            }),
                            remisionAutomatica: configuracion._id ? configuracion.remisionAutomatica !== false : true,
                            observaciones: configuracion.observaciones,
                            preciosEspeciales: especiales,
                            agrupacionMapa: Object.fromEntries(
                                (configuracion.agrupacionFactura || []).map((a) => [a.comboId ? `k_${a.comboId}` : `c_${a.conceptoId}`, a.agrupar ? "agrupar" : "aparte"])
                            ),
                        }}
                    >
                        <TabbedDynamicTable
                            formInstance={this.formRef}
                            defaultActiveKey="generales"
                            tabs={[
                                { key: "generales", label: "Configuración", forceRender: true, customContent: this.renderGenerales() },
                                {
                                    key: "especiales",
                                    label: "Precios especiales",
                                    forceRender: true,
                                    listName: "preciosEspeciales",
                                    minWidth: "100%",
                                    columns: [
                                        { title: "Concepto o combo", width: "28%" },
                                        { title: "Aplica a", width: "22%" },
                                        { title: "Tipo", width: "13%" },
                                        { title: "Valor", width: "12%" },
                                        { title: "Motivo" },
                                        { title: "", width: "5%" },
                                    ],
                                    renderRow: ({ key, name, remove }) => (
                                        <tr key={key}>
                                            <Celda>
                                                <Campo name={[name, "objetivo"]} required>
                                                    <SelectItem width="100%" placeholder="Concepto o combo" showSearch optionFilterProp="label" options={this.opcionesObjetivo()} />
                                                </Campo>
                                            </Celda>
                                            <Celda>
                                                <Campo name={[name, "empresaId"]}>
                                                    <SelectItem width="100%" options={opcionesEmpresa} />
                                                </Campo>
                                            </Celda>
                                            <Celda>
                                                <Campo name={[name, "tipo"]} required>
                                                    <SelectItem width="100%" options={[{ value: "fijo", label: "Precio fijo" }, { value: "porcentaje", label: "% descuento" }]} />
                                                </Campo>
                                            </Celda>
                                            <Celda>
                                                <Campo name={[name, "valor"]} required>
                                                    <InputNumberItem min={0} />
                                                </Campo>
                                            </Celda>
                                            <Celda>
                                                <Campo name={[name, "motivo"]}>
                                                    <InputItem placeholder="Motivo del precio especial" />
                                                </Campo>
                                            </Celda>
                                            <Celda>
                                                <div style={{ display: "flex", justifyContent: "center" }}>
                                                    <Tooltip title="Quitar">
                                                        <ButtonItem size="small" danger icon={<DeleteOutlined />} onClick={() => remove(name)} />
                                                    </Tooltip>
                                                </div>
                                            </Celda>
                                        </tr>
                                    ),
                                    renderFooter: ({ add }) => (
                                        <ButtonItem cyan size="small" icon={<PlusOutlined />} style={{ marginTop: 10 }} onClick={() => add({ empresaId: "", tipo: "fijo" })}>
                                            Agregar precio especial
                                        </ButtonItem>
                                    ),
                                },
                                { key: "factura", label: "Factura", forceRender: true, customContent: this.renderAgrupacion() },
                                { key: "calculo", label: "Cálculo del periodo", customContent: this.renderCalculo() },
                            ]}
                        />
                        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16, paddingTop: 12, borderTop: "1px solid #f0f0f0" }}>
                            <Space>
                                <ButtonItem danger onClick={cerrar}>Cerrar</ButtonItem>
                                <ButtonItem cyan onClick={this.guardar}>Guardar y recalcular</ButtonItem>
                            </Space>
                        </div>
                    </Form>
                )}
            </>
        );
    }

    renderPagina() {
        const { master } = this.state;
        return (
            <>
                <PageHeader
                    onBack={this.volver}
                    title={master ? `Cobro de ${master.nombre}` : "Cobro del master"}
                    subTitle={master?.nombreCorporativo || ""}
                    style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
                />
                <div className="card-background">
                    <Spin spinning={!!this.state.cargandoMaster}>
                        {this.state.noEncontrado ? <div style={{ padding: 40, textAlign: "center" }}>No se encontró el master</div> : this.renderContenido()}
                    </Spin>
                </div>
            </>
        );
    }

    render() {
        if (this.props.usuarioId) return this.renderPagina();
        return (
            <>
                <div style={TARJETA}>
                    <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: 12, marginBottom: 12 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <span style={{ fontSize: 16, fontWeight: 600, color: "#333" }}>Masters</span>
                            <TagItem cyan style={{ margin: 0 }}>{this.state.masters.length}</TagItem>
                        </div>
                        <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 8 }}>
                            <InputItem
                                placeholder="Buscar master, corporativo o empresa"
                                prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
                                allowClear
                                style={{ width: 320, maxWidth: "100%" }}
                                value={this.state.texto}
                                onChange={(e) => this.setState({ texto: e.target.value }, e.target.value ? undefined : this.consultar)}
                                onPressEnter={this.consultar}
                            />
                            <ButtonItem cyan size="small" icon={<SearchOutlined />} onClick={this.consultar}>Buscar</ButtonItem>
                        </div>
                    </div>
                    <TableItem
                        size="small"
                        loading={this.state.loading}
                        dataSource={this.state.masters.map((m) => ({ ...m, empresasTexto: m.empresas.map((e) => e.nombre).join(", ") }))}
                        onRow={(m) => ({ onDoubleClick: () => this.irAMaster(m) })}
                        columns={[
                            { title: "Master", dataIndex: "nombre", buscar: "nombre" },
                            { title: "Corporativo", dataIndex: "nombreCorporativo", buscar: "nombreCorporativo" },
                            {
                                title: "Empresas",
                                buscar: "empresasTexto",
                                render: (m) => {
                                    const nombres = m.empresas.map((e) => e.nombre).join(", ");
                                    return <Tooltip title={nombres}>{nombres}</Tooltip>;
                                },
                            },
                            { title: "Usuarios", render: (m) => m.conteos.usuarios, width: 90, align: "right", sorter: (a, b) => (a.conteos.usuarios || 0) - (b.conteos.usuarios || 0) },
                            {
                                title: "Cobro",
                                width: 320,
                                filters: [
                                    { text: "Sin configurar", value: "sinConfigurar" },
                                    { text: "Activo", value: "activo" },
                                    { text: "Pausado", value: "pausado" },
                                    { text: "Mensual", value: "mensual" },
                                    { text: "Anual", value: "anual" },
                                    { text: "Cobro pendiente", value: "pendiente" },
                                ],
                                onFilter: (valor, m) => {
                                    if (valor === "sinConfigurar") return !m.configuracion;
                                    if (valor === "pendiente") return !!m.pendiente;
                                    if (!m.configuracion) return false;
                                    if (valor === "activo") return !!m.configuracion.activo;
                                    if (valor === "pausado") return !m.configuracion.activo;
                                    return m.configuracion.periodicidad === valor;
                                },
                                render: (m) =>
                                    !m.configuracion ? (
                                        <TagItem gris>Sin configurar</TagItem>
                                    ) : (
                                        <>
                                            {m.configuracion.activo ? <TagItem verdeNatural>Activo</TagItem> : <TagItem naranja>Pausado</TagItem>}
                                            {m.configuracion.periodicidad} · {nombreDocumento(m.configuracion.tipoDocumento)} · {Number.isInteger(m.configuracion.diasAntesEmision) ? m.configuracion.diasAntesEmision : 10} días antes del corte
                                            {m.pendiente && (
                                                <Tooltip title={m.pendiente}>
                                                    <TagItem naranja style={{ marginLeft: 6 }}>Cobro pendiente</TagItem>
                                                </Tooltip>
                                            )}
                                        </>
                                    ),
                            },
                            {
                                title: "Acciones",
                                key: "acciones",
                                width: 90,
                                render: (m) => (
                                    <Space>
                                        <Tooltip title="Configurar cobro">
                                            <ButtonItem cyan size="small" icon={<SettingOutlined />} onClick={() => this.irAMaster(m)} />
                                        </Tooltip>
                                    </Space>
                                ),
                            },
                        ]}
                    />
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => ({ headersToken: state.user.headersToken });

export default withRouter(connect(mapStateToProps)(MastersCobro));
